import styled from 'styled-components';
import { error } from 'constants/variables';

export interface ErrorProps {
  errorMessage: string;
}

const StyledError = styled.div`
  color: ${error};
`;

const InputError = ({ errorMessage }: ErrorProps) => (
  <StyledError className="cef-ui-input-error">{errorMessage}</StyledError>
);

export default InputError;
